<template>
  <transition name="fade">
    <box v-show="show" style="width:60vw;height: 50vh">
      <template v-slot:body>
        <!-- <img src="@/assets/lin-3.png" class="box-lin" /> -->
        <img src="@/assets/holdingbook.gif" class="box-lin" />
        <img src="@/assets/book-1.png" class="box-book1" />
        <img src="@/assets/book-2.png" class="box-book2" />
        <div class="main">
          <p class="main-header">我是一個被創造的人物，寫我的人他說：</p>
          <p class="main-body">
            「我在臺北生活很久了，都市生活給我很多想法和感觸，我既是寫小說的人，寫出我對臺北的看法，應該是很自然的。」
          </p>
          <p class="main-header">他還寫了這些小說：</p>
        </div>
        <div class="bottom">
          <choice
            v-if="clickIndex >= 0"
            style="min-height: 6vh; width: 13vw; font-size: 1em"
            text="〈玫瑰玫瑰我愛你〉"
            @goNext="goNext"
          ></choice>
          <transition name="bounceRight">
            <choice
              v-if="clickIndex >= 1"
              style="min-height: 6vh; width: 11vw; font-size: 1em; animation-duration: 1.5s"
              text="〈嫁妝一牛車〉"
              @goNext="goNext"
            ></choice>
          </transition>
          <transition name="bounceRight">
            <choice
              v-if="clickIndex >= 2"
              style="min-height: 6vh; width: 11vw; font-size: 1em; animation-duration: 1.5s"
              text="〈來春姨悲秋〉"
              @goNext="goNext"
            ></choice>
          </transition>
          <transition name="bounceRight">
            <choice
              v-if="clickIndex >= 3"
              style="min-height: 6vh; width: 9vw; font-size: 1em; animation-duration: 1.5s"
              text="〈伊會唸咒〉"
              @goNext="goNext"
            ></choice>
          </transition>
        </div>
      </template>
    </box>
  </transition>
</template>
<script>
import Box from "@/components/Box";
import Choice from "@/components/Choice.vue";

export default {
  components: { Box, Choice },
  data() {
    return {
      clickIndex: 0,
      show: false
    };
  },
  mounted() {
    setTimeout(() => {
      this.show = true;
    }, 300);
  },
  methods: {
    goNext() {
      if (this.clickIndex === 3) this.$router.push("marguee");
      if (this.clickIndex < 3) this.clickIndex++;
    }
  }
};
</script>
<style lang="scss" scoped>
.main {
  margin-top: 1.5em;
  padding-left: 5em;

  .main-header {
    width: 80%;
    margin-top: 1.5em;
    word-wrap: break-word;
    font-size: 1.5em;
    font-weight: bold;
    color: #965151;
  }

  .main-body {
    width: 80%;
    word-wrap: break-word;
    margin-top: 1.2em;
    font-size: 1em;
    font-weight: 600;
    color: #965151;
  }
}
.bottom {
  margin-top: 0em;
  padding-left: 5em;
}
.box-lin {
  position: absolute;
  bottom: -8em;
  right: -4em;
  height: 18vw;
}
.box-book1 {
  position: absolute;
  bottom: 10em;
  left: -3em;
  width: 8vw;
}
.box-book2 {
  position: absolute;
  bottom: 5em;
  left: -5em;
  width: 8vw;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
